/**
 * EmptyState — the one canonical "nothing here yet" block.
 *
 * Wraps the global .empty-state + .empty-state-icon / -message / -hint classes
 * (apps/portal/src/styles/global.css) — the same set DataTable renders for its
 * empty list — so empty/zero states look identical everywhere instead of being
 * hand-built per page with inline padding + centring + a big emoji.
 *
 * `action` is an optional call-to-action (pass a <button className="btn …">).
 */

import type { ReactNode } from 'react';

interface EmptyStateProps {
  /** Optional leading icon/emoji. */
  icon?: ReactNode;
  /** The main line. */
  message: ReactNode;
  /** Optional secondary line under the message. */
  hint?: ReactNode;
  /** Optional call-to-action below the text. */
  action?: ReactNode;
}

export default function EmptyState({ icon, message, hint, action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      {icon && <div className="empty-state-icon">{icon}</div>}
      <p className="empty-state-message">{message}</p>
      {hint && <p className="empty-state-hint">{hint}</p>}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
}
